function backupEventCategory(boxGroup) {
  if (boxGroup === 'BACKUPS') {
    return 'WR_backups';
  } else if (boxGroup === 'ARCHIVES') {
    return 'WR_archives';
  } else if (boxGroup === 'SYNC') {
    return 'WR_syncs';
  }

  console.log('Undefined box group', boxGroup);
  return 'WR_undefined';
}

export default backupEventCategory;
